var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "notification-dialog-template",
    {
      class: _vm.$style.dialog,
      attrs: { icon: "exclamation" },
      on: {
        cancel: function ($event) {
          return _vm.cancel()
        },
      },
    },
    [
      _c("template", { slot: "subTitle" }, [
        _vm._v(" " + _vm._s(_vm.subtitle) + " "),
      ]),
      _c("template", { slot: "title" }, [_vm._v(" Please Read! ")]),
      _c("template", { slot: "message" }, [
        _c("p", { class: _vm.$style.text }, [
          _vm._v(
            "Email notifications for new final agreements are sent once a day as an aggregated, single report to your Chain Partner."
          ),
        ]),
        _c("p", { class: _vm.$style.text }, [
          _vm._v(
            "Keep in mind, direct-to-property final agreement email notifications are sent immediately to hotel representatives."
          ),
        ]),
        _c("p", { class: _vm.$style.text }, [
          _vm._v(
            "In either case their Bid Managers will reflect final agreement status immediately."
          ),
        ]),
      ]),
      _c("template", { slot: "footer" }, [
        _c("div", { class: _vm.$style.footer }, [
          _vm.disabled
            ? _c("div")
            : _c(
                "div",
                { class: _vm.$style.checkbox },
                [
                  _c("v-checkbox", {
                    attrs: { checked: _vm.dontShowThisAgain },
                    on: { change: _vm.setDontShowThisAgain },
                  }),
                  _vm._v(" Don't show this again "),
                ],
                1
              ),
          _c(
            "div",
            [
              _c(
                "v-button",
                {
                  attrs: { type: "main" },
                  on: {
                    click: function ($event) {
                      return _vm.onClose()
                    },
                  },
                },
                [_vm._v(" OK ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }